import { render, staticRenderFns } from "./AddSkillModal.vue?vue&type=template&id=5506e14e&scoped=true&"
import script from "./AddSkillModal.vue?vue&type=script&lang=js&"
export * from "./AddSkillModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5506e14e",
  null
  
)

export default component.exports